// extracted by mini-css-extract-plugin
export default {"root":"AssetAccountDialog_root__UEZJD"};